import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MatDialogModule } from '@angular/material/dialog';
import { UserService } from './services/user.service';
import { CommonModule } from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { TourService } from './services/tour.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    RouterOutlet,
    RouterLink,
    FooterComponent,
    MatDialogModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Consumer';
  enableSpinner = true

  constructor (private _userService : UserService) {}

  ngOnInit() {
    this._userService.isLoading.subscribe(value => {
      Promise.resolve().then(() => { this.enableSpinner = value })
    })
    if (localStorage.getItem('CSIPUser') != null) {
      const user = JSON.parse(localStorage.getItem('CSIPUser') || '{}')
      this._userService.setUserDetails(user);
      
    }
  }
}
